module.exports = __webpack_public_path__ + "static/quizbaker2-d1a19d1746be49f277b07b214dc2e2c8.png";